<template>
  <div class="eliminated-page row">
    <div class="col-12">
      <Hero
      image="banner-home.png"
        layout="lg"
        title=""
      />
    </div>

    <div class="col-12">
      <div class="row pb-5">
        <div class="col-12 col-lg-8 mx-auto mt-n5">
          <div class="bg-white shadow-sm p-5">
            <div class="d-flex align-items-center justify-content-center">

              <alert-circle-outline-icon style="font-size:120px;" class="text-color-1"/>

              <div class="m-3" v-html="template"></div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Hero from "@/components/media/Hero.vue";
import AlertCircleOutlineIcon from "vue-material-design-icons/AlertCircleOutline.vue";
export default {
  name: "EliminatedByQuestions",
  computed: {
    template(){
      return this.$route.params.template
    }
  },
  components: {
    Hero,
    AlertCircleOutlineIcon
  }
};
</script>

<style lang="scss" scoped>
  .eliminated-page{
    background: #F5F5F5;
  }

  /deep/ .hero{
    height: 450px;
    min-height: auto;
    margin-top: 123px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    .media-content img{
      object-position: center !important;
    }

    @media (max-width: 600px){
      background-size: cover;
    }
  }
</style>